import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=54acb107&lang=pug&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54acb107')) {
      api.createRecord('54acb107', component.options)
    } else {
      api.reload('54acb107', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=54acb107&lang=pug&", function () {
      api.rerender('54acb107', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/Settings.vue"
export default component.exports